import i18n from "@microdoing/shared/i18n";

// ^^ Start of DailyFocus

const dailyFocusBreadcrumb = {
  routeName: "DailyFocusScreen",
  label: i18n.t("breadcrumb-campaign"),
};

const dailyFocusSelectActionBreadcrumb = {
  routeName: "SelectAction",
  label: i18n.t("breadcrumb-challenge"),
};

const dailyFocusActionBreadcrumb = {
  routeName: "Action",
  label: i18n.t("breadcrumb-challenge-selected"),
};

const dailyFocusCertificateBreadcrumb = {
  routeName: "CertificateScreen",
  label: i18n.t("breadcrumb-certification"),
};

export const breadCrumbsDailyFocusScreen = [dailyFocusBreadcrumb];

export const breadCrumbsSelectActionScreen = [
  ...breadCrumbsDailyFocusScreen,
  dailyFocusSelectActionBreadcrumb,
];

export const breadCrumbsDailyFocusActionScreen = [
  ...breadCrumbsDailyFocusScreen,
  dailyFocusActionBreadcrumb,
];

export const breadCrumbsDailyFocusCertificationScreen = [
  ...breadCrumbsDailyFocusScreen,
  dailyFocusCertificateBreadcrumb,
];

// ^^ End of DailyFocus

// ^^ Start of Progression

const progressionBreadcrumb = {
  routeName: "ProgressScreen",
  label: i18n.t("breadcrumb-progress"),
};

const userRankingBreadcrumb = {
  routeName: "UserRanking",
  label: i18n.t("breadcrumb-progress-user-ranking"),
};

const afestActionBreadcrumb = {
  routeName: "HistoricalList",
  label: i18n.t("breadcrumb-progress-afest-action"),
};

const afestDetailDActionBreadcrumb = {
  routeName: "HistoricalAction",
  label: i18n.t("breadcrumb-progress-afest-action-detail"),
};

const afestReviewChatDActionBreadcrumb = {
  routeName: "ReviewChatScreen",
  label: i18n.t("breadcrumb-progress-afest-action-review-chat"),
};

export const breadCrumbsProgressScreen = [progressionBreadcrumb];

export const breadCrumbsUserRankingScreen = [
  ...breadCrumbsProgressScreen,
  userRankingBreadcrumb,
];

export const breadCrumbsActionAfest = [
  ...breadCrumbsProgressScreen,
  afestActionBreadcrumb,
];

export const breadCrumbsActionAfestDetails = [
  ...breadCrumbsActionAfest,
  afestDetailDActionBreadcrumb,
];

export const breadCrumbsActionAfestReviewChatScreen = [
  ...breadCrumbsActionAfestDetails,
  afestReviewChatDActionBreadcrumb,
];

// ^^ End of Progression

// ^^ Start of Team

const teamBreadcrumb = {
  routeName: "TeamScreen",
  label: i18n.t("breadcrumb-team"),
};

const teamRankingBreadcrumb = {
  routeName: "TeamRanking",
  label: i18n.t("breadcrumb-team-ranking"),
};

export const breadCrumbsTeamScreen = [teamBreadcrumb];

export const breadCrumbsTeamRankingScreen = [
  ...breadCrumbsTeamScreen,
  teamRankingBreadcrumb,
];

// ^^ End of Team

export const breadCrumbsConversationScreen = [
  {
    routeName: "Message",
    label: i18n.t("breadcrumb-conversations"),
  },
];

export const breadCrumbsNotificationScreen = [
  {
    routeName: "Notifications",
    label: i18n.t("breadcrumb-notifications"),
  },
];

// ^^ Start of Profile

const profileBreadCrumb = {
  routeName: "UserProfile",
  label: i18n.t("breadcrumb-profile"),
};

const settingsBreadCrumb = {
  routeName: "UserProfileSettings",
  label: i18n.t("breadcrumb-profile-settings"),
};

const mbtiBreadCrumb = {
  routeName: "Mbti",
  label: i18n.t("breadcrumb-profile-mbti"),
};

const discBreadCrumb = {
  routeName: "Disc",
  label: i18n.t("breadcrumb-profile-disc"),
};

const legalBreadCrumb = {
  routeName: "Legal",
  label: i18n.t("breadcrumb-profile-legal"),
};

const profileCertificateBreadcrumb = {
  routeName: "CertificateScreen",
  label: i18n.t("breadcrumb-certification"),
};

export const breadCrumbsProfileScreen = [profileBreadCrumb];

export const breadCrumbsProfileSettingsScreen = [
  ...breadCrumbsProfileScreen,
  settingsBreadCrumb,
];
export const breadCrumbsProfileCertificationScreen = [
  ...breadCrumbsProfileScreen,
  profileCertificateBreadcrumb,
];

export const breadCrumbsMbtiScreen = [
  ...breadCrumbsProfileSettingsScreen,
  mbtiBreadCrumb,
];

export const breadCrumbsDiscScreen = [
  ...breadCrumbsProfileSettingsScreen,
  discBreadCrumb,
];

export const breadCrumbsLegalScreen = [
  ...breadCrumbsProfileSettingsScreen,
  legalBreadCrumb,
];

export const breadCrumbsExternalProfileScreen = [
  {
    routeName: "ExternalProfile",
    label: i18n.t("breadcrumb-profile"),
  },
];

// ^^ End of Profile

// ^^ Start of Campaign

const campaignBreadCrumb = {
  routeName: "DailyFocusScreen",
  label: i18n.t("breadcrumb-campaign"),
};

const challengeSelectionBreadCrumb = {
  routeName: "SelectAction",
  label: i18n.t("breadcrumb-select-challenge"),
};

export const breadCrumbsSelectAction = [
  campaignBreadCrumb,
  challengeSelectionBreadCrumb,
];

export const breadCrumbsCancelActionScreen = [
  campaignBreadCrumb,
  {
    routeName: "CancelAction",
    label: i18n.t("breadcrumb-cancel-action"),
  },
];

// ^^ End of Campaign

// ^^ Start of Reflexive analysis

const analysisTypeBreadCrumb = {
  routeName: "ReflexiveAnalysisType",
  label: i18n.t("breadcrumb-reflexive-analysis"),
};

const analysisReflexiveBreadCrumb = {
  routeName: "ReflexiveAnalysisScreen",
  label: i18n.t("breadcrumb-analysis"),
};

const analysisReflexiveFeelingBreadCrumb = {
  routeName: "ActionFeelingScreen",
  label: i18n.t("breadcrumb-reflexive-analysis-feeling"),
};

const analysisReflexiveRatingBreadCrumb = {
  routeName: "ActionRatingScreen",
  label: i18n.t("breadcrumb-reflexive-analysis-rating"),
};

const analysisReflexiveRecapBreadCrumb = {
  routeName: "RecapFeedbackScreen",
  label: i18n.t("breadcrumb-reflexive-analysis-recap"),
};

const analysisReflexiveResultBreadCrumb = {
  routeName: "ResultScreen",
  label: i18n.t("breadcrumb-reflexive-result"),
};

const analysisNextActionBreadCrumb = {
  routeName: "NextActionScreen",
  label: i18n.t("breadcrumb-reflexive-next-action"),
};

export const breadCrumbsReflexiveAnalysisResult = [
  analysisReflexiveResultBreadCrumb,
];
export const breadCrumbsReflexiveAnalysisNextAction = [
  ...breadCrumbsReflexiveAnalysisResult,
  analysisReflexiveResultBreadCrumb,
];

export const breadCrumbsReflexiveAnalysisTypeScreen = [
  campaignBreadCrumb,
  analysisTypeBreadCrumb,
];

export const breadCrumbsReflexiveAnalysisScreen = [
  ...breadCrumbsReflexiveAnalysisTypeScreen,
  analysisReflexiveBreadCrumb,
];
export const breadCrumbsReflexiveAnalysisFeelingScreen = [
  ...breadCrumbsReflexiveAnalysisScreen,
  analysisReflexiveFeelingBreadCrumb,
];

export const breadCrumbsReflexiveAnalysisRatingScreen = [
  ...breadCrumbsReflexiveAnalysisFeelingScreen,
  analysisReflexiveRatingBreadCrumb,
];

export const breadCrumbsReflexiveAnalysisRecapScreen = [
  ...breadCrumbsReflexiveAnalysisRatingScreen,
  analysisReflexiveRecapBreadCrumb,
];

// ^^ End of Reflexive analysis
